type ScriptConfig = {
  src: string;
  async?: boolean;
  defer?: boolean;
  id?: string;
  waitFor?: () => Promise<void>;
};

export const loadedScripts = new Map<string, Promise<void>>();

export const loadScript = (config: ScriptConfig): Promise<void> => {
  // If script is already loaded, resolve immediately
  if (loadedScripts.has(config.src)) {
    // Return the promise that we already have
    return loadedScripts.get(config.src)!;
  }

  const promise = new Promise<void>((resolve, reject) => {

    const script = document.createElement('script');
    script.src = config.src;
    script.async = config.async ?? true;
    script.defer = config.defer ?? false;
    
    if (config.id) {
      script.id = config.id;
    }

    script.onload = async () => {
      await config.waitFor?.()
      resolve();
    };

    script.onerror = (error) => {
      // Clean up on error
      script.remove();
      reject(new Error(`Failed to load script: ${config.src}`));
    };

    document.body.appendChild(script);
  });

  loadedScripts.set(config.src, promise);
  return promise;
};

export const loadScripts = async (scripts: ScriptConfig[]): Promise<void> => {
  try {
    await Promise.all(scripts.map(script => loadScript(script)));
  } catch (error) {
    console.error('Error loading scripts:', error);
    throw error;
  }
};